import { TransferConstructionSiteDetailPrintModel } from "./transfer-construction-site-detail-print.model";

export class TransferConstructionSitePrintModel {
    transferConstructionSiteId: number = 0;
    consecutive: number = 0;
    companyId: number = 0;
    branchId: number = 0;
    branchCode: number = 0;
    branchName: string = '';
    enterpriseId: number = 0;
    enterpriseName: string = '';
    departmentCityBranch: string = '';
    addressBranch: string = '';
    phoneBranch: string = '';
    nameTransferConstructionSite: string = '';
    dateTransferConstructionSite: Date = new Date();
    consecutiveRemission: number = 0;
    consecutiveDevolution: number = 0;
    // Centro de costos => Origen
    originCostCenterId: number = 0;
    originCostCenterCodeName: string = '';
    originClientNitAndBusinessName: string = '';
    originTransporterName: string = '';
    // Centro de costos => Destino
    destinyCostCenterId: number = 0;
    destinyCostCenterCodeName: string = '';
    destinyClientNitAndBusinessName: string = '';
    destinyTransporterName: string = '';
    observation: string = '';
    transferConstructionSiteDetails: TransferConstructionSiteDetailPrintModel[] = [];

}